export default "__VITE_ASSET__DHpb1Lm8__"